import { api } from './api';

export interface Romaneio {
  id: string;
  idFuncionario: string;
  idPraca: string;
  dataSaida: string;
  dataRetorno: string;
  finalizado: boolean;
  nomePromotor?: string;
  nomePraca?: string;
  funcionario?: string;
  praca?: string;
  dataSaidaString?: string;
  dataRetornoString?: string;
  devolvido?: boolean;
  produtos?: ProdutoRomaneio[];
}

export interface ProdutoRomaneio {
  id: string;
  idRomaneio: string;
  idProduto: string;
  codigoBarras?: string;
  quantidade: number;
  quantidadeDevolvida?: number;
  precoVenda?: string;
  nomeProduto?: string;
  referencia?: string;
  quantidadeDisponivel?: number;
  idSacola?: string;
  valorTotal?: number;
}

export interface RomaneioSelect {
  id: number;
  idPraca: number;
  praca: string;
  idFuncionario: number;
  funcionario: string;
  data: string;
  dataString: string;
}

export interface RomaneioConferenciaPayload {
  Id: number;
  Produtos: {
    id: number;
    idRomaneio: number;
    codProduto: number;
    quantidadeDevolvida: number;
  }[];
}

export const romaneioService = {
  getAll: async (): Promise<Romaneio[]> => {
    const response = await api.get<Romaneio[]>('/api/Romaneio/GetAll');
    return response.data;
  },

  getRomaneioSelect: async (): Promise<RomaneioSelect[]> => {
    const response = await api.get<RomaneioSelect[]>('/api/Romaneio/GetRomaneioSelect');
    return response.data;
  },

  getByIdPraca: async (idPraca: number): Promise<RomaneioSelect[]> => {
    const response = await api.get<RomaneioSelect[]>(`/api/Romaneio/GetRomaneioSelectByIdPraca?idPraca=${idPraca}`);
    return response.data;
  },

  getById: async (id: string): Promise<Romaneio> => {
    const response = await api.get<Romaneio>(`/api/Romaneio/GetById?id=${id}`);
    return response.data;
  },

  salvar: async (romaneio: Partial<Romaneio>): Promise<Romaneio> => {
    const response = await api.post<Romaneio>('/api/Romaneio/Salvar', romaneio);
    return response.data;
  },

  salvarDatas: async (data: {
    id: string;
    novaDataSaidaRomaneio: string;
    dataSaidaRomaneio: string;
    novaDataRetornoRomaneio: string;
    dataRetornoRomaneio: string;
    finalizado: boolean;
  }): Promise<Romaneio[]> => {
    const response = await api.post<Romaneio[]>('/api/Romaneio/SalvarDatas', data);
    return response.data;
  },

  devolverItensRomaneio: async (id: string): Promise<Romaneio[]> => {
    const response = await api.get<Romaneio[]>(`/api/Romaneio/DevolverItensRomaneio?id=${id}`);
    return response.data;
  },

  buscarProdutoPorCodigoBarraNoRomaneio: async (codigo: string, codRomaneio: string): Promise<ProdutoRomaneio> => {
    const response = await api.get<ProdutoRomaneio>(`/api/Romaneio/BuscarProdutoPorCodigoBarraNoRomaneio?idRomaneio=${codRomaneio}&codigoBarra=${codigo}`);
    return response.data;
  },

  salvarConferencia: async (romaneio: RomaneioConferenciaPayload): Promise<Romaneio> => {
    const response = await api.post<Romaneio>('/api/Romaneio/SalvarConferencia', romaneio);
    return response.data;
  },

  salvarConferenciaSaida: async (romaneio: Partial<Romaneio>): Promise<Romaneio> => {
    const response = await api.post<Romaneio>('/api/Romaneio/SalvarConferenciaSaida', romaneio);
    return response.data;
  },

  imprimir: async (id: string): Promise<void> => {
    try {
      const response = await api.get(`/api/Romaneio/RomaneioPDF?id=${id}`, {
        responseType: 'blob',
      } as any);
      
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      const fileName = `Romaneio_${Date.now()}.pdf`;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
      throw error;
    }
  }
};
